export default __webpack_public_path__ + "static/media/os_1.54fe8937.mp3";